:host {
  --app-header-content-max-width: ;

  /* Variable to set stuck header and drawer's top offset.
  Useful when something is absolutely positioned above the header. */
  --app-header-top-offset: ;

  /* Variable to customize header background color. */
  --app-header-bg: ;

  /* Variable to customize text and icon color. */
  --app-header-text-color: ;

  /* Variable to customize stuck header background color. */
  --app-header-stucked-bg: ;

  /* Variable to customize stuck header's text and icon color. */
  --app-header-stucked-text-color: ;

  position: relative;
  display: block;
  box-shadow: var(--shadow-2);
}

:host,
* {
  box-sizing: border-box;
}

.heading-panel {
  /* Title's line height. */
  --title-line-height: 1.333;
  --title-font-size: var(--font-size-6);

  position: relative;
  display: flex;
  width: 100%;
  max-width: var(--app-header-content-max-width, 100%);
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: baseline;
  padding: calc(var(--space-unit) * 2);
  margin: 0 auto;
  background: var(--app-header-bg, var(--color-surface01));
}

:host(:empty) .heading-panel {
  padding: 0;
}

.heading-container {
  position: relative;
  z-index: 1;
  display: flex;
  width: 100%;
  max-width: 100%;
  flex: 1 auto;
  flex-direction: column;
  justify-content: flex-start;
}

.heading-panel.has-menubar {
  padding-bottom: 0;
}

.heading-panel .heading-container {
  flex-direction: column-reverse;
}

:host([enable-search]) .heading-panel .heading-container {
  flex-direction: column;
}

:host([enable-search][search-page-url]) .heading-panel .heading-container {
  flex-direction: row;
}

.heading-title {
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: flex-start;
}

.heading-title:not(:last-child) {
  margin-right: var(--space-unit);
}

.z-logo,
.search-page-button {
  display: flex;
  height: calc(var(--title-font-size) * var(--title-line-height));
  align-items: center;
}

.z-logo img {
  height: 24px;
  margin: 0 var(--space-unit) 0 0;
  content: url('data:image/svg+xml,<svg width="61" height="32" viewBox="0 0 61 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.9874 32C7.1595 32 0 24.8349 0 16C0 7.16513 7.1595 0 15.9874 0H45.0126C53.8405 0 61 7.16513 61 16C61 24.8349 53.8405 32 45.0126 32H15.9874Z" fill="%23E2011A"/><path d="M58.5435 15.9992C58.5435 23.4743 52.4892 29.5403 45.0129 29.5403C37.5367 29.5403 31.4824 23.4813 31.4824 15.9992C31.4824 8.51701 37.5367 2.45801 45.0129 2.45801C52.4892 2.45801 58.5435 8.51701 58.5435 15.9992Z" fill="white"/><path d="M40.7107 8.01862H49.8976V11.3158L44.139 21.7077H50.0384V24.6457H39.9785V21.4048L45.7371 10.9636H40.7107V8.01862Z" fill="%23E2011A"/><path d="M12.2914 24.6449C10.982 24.6449 10.271 23.8136 10.271 22.6722V7.04565H12.1718V22.9822H13.981V24.6449H12.2914Z" fill="white"/><path d="M25.6461 24.6448C24.2452 24.6448 23.675 23.7853 23.5342 22.6439H23.4145C22.8935 24.1446 21.5841 24.9266 19.8735 24.9266C17.2828 24.9266 15.7622 23.4964 15.7622 21.2137C15.7622 18.931 17.4236 17.6206 20.9928 17.6206H23.4145V16.4088C23.4145 14.6756 22.4641 13.7245 20.5141 13.7245C19.0428 13.7245 18.0642 14.4361 17.4025 15.5563L16.262 14.4854C16.9308 13.175 18.4021 12.0829 20.6126 12.0829C23.5623 12.0829 25.3152 13.6259 25.3152 16.2186V22.9751H26.7162V24.6378H25.6461V24.6448ZM23.4145 21.0799V19.0578H20.8942C18.733 19.0578 17.7545 19.7272 17.7545 20.9108V21.411C17.7545 22.6228 18.7049 23.3132 20.1762 23.3132C22.0558 23.3132 23.4074 22.341 23.4074 21.0799H23.4145Z" fill="white"/></svg>');
}

.product-logo {
  display: none;
}

.product-logo ::slotted([slot="product-logo"]) {
  width: 32px;
  height: 32px;
  margin-right: var(--space-unit);
}

.product-logo ::slotted([slot="product-logo"]) img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

::slotted([slot="title"]),
::slotted([slot="stucked-title"]),
.stucked-title {
  margin: 0;
  color: var(--app-header-text-color, var(--color-default-text));
  font-family: var(--font-family-serif);
  font-weight: var(--font-sb);
}

::slotted([slot="title"]) {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  font-size: var(--title-font-size);
  -webkit-line-clamp: 2;
  line-clamp: 2;
  line-height: var(--title-line-height);
  text-overflow: ellipsis;
}

::slotted(a:is([slot="title"], [slot="stucked-title"])) {
  text-decoration: none;
}

:host([enable-search]) ::slotted([slot="title"]) + * {
  margin-left: calc(var(--space-unit) * 2);
}

:host([enable-offcanvas]:not([menu-length="0"])) .top-subtitle {
  padding-left: calc(var(--space-unit) * 4 + var(--space-unit));
}

::slotted([slot="top-subtitle"]) {
  display: -webkit-box;
  overflow: hidden;
  max-width: 80%;
  margin: 0;
  -webkit-box-orient: vertical;
  color: var(--color-default-text);
  font-family: var(--font-family-sans);
  font-size: var(--font-size-2);
  font-style: italic;
  font-weight: var(--font-rg);
  -webkit-line-clamp: 2;
  line-clamp: 2;
}

.search-page-button {
  margin-left: auto;
}

.menu-container {
  display: flex;
  flex: 1 auto;
  column-gap: calc(var(--space-unit) * 4);
}

.menu-container:focus:focus-visible {
  outline: none;
}

:host([menu-length="0"]) .menu-container,
.menu-container:empty {
  display: none;
}

.menu-container ::slotted([open]) {
  position: relative;
  z-index: 3;
}

.menu-container ::slotted([slot="menu"]:not(:last-child))::after {
  position: absolute;
  top: calc(1.5em / 2); /* half the line-height of the label */
  right: calc(var(--space-unit) * -2);
  width: var(--border-size-small);
  height: 1em;
  background-color: currentcolor;
  content: "";
  font-size: var(--font-size-3);
  transform: translateY(-50%);
}

z-searchbar {
  z-index: 0;
  display: flex;
  width: 100%;
  align-items: center;
}

.heading-stuck {
  position: fixed;
  z-index: 20;
  top: var(--app-header-top-offset, 48px);
  left: 0;
  width: 100%;
  max-width: 100%;
  animation: slide-stuck-heading-in 250ms ease-out;
  background: var(--app-header-stucked-bg, var(--color-surface01));
  box-shadow: var(--shadow-2);
  color: var(--app-header-stucked-text-color, var(--color-default-text));
}

.heading-stuck-content {
  display: flex;
  max-width: var(--app-header-content-max-width, 100%);
  align-items: center;
  padding: var(--space-unit) var(--grid-margin);
  margin: 0 auto;
}

.heading-stuck .heading-title {
  --title-font-size: var(--font-size-5);
  --title-line-height: 1.4;

  overflow: hidden;
  align-items: center;
}

.heading-stuck .stucked-title {
  overflow: hidden;
  font-size: var(--title-font-size);
  line-height: var(--title-line-height);
  text-overflow: ellipsis;
  white-space: nowrap;
}

.drawer-trigger {
  display: flex;
  height: calc(var(--title-font-size) * var(--title-line-height));
  align-items: center;
  padding: 0;
  border: 0;
  margin-right: var(--space-unit);
  appearance: none;
  background: none;
  border-radius: 0;
  color: inherit;
  cursor: pointer;
  outline: none;
}

.drawer-trigger:focus:focus-visible z-icon {
  box-shadow: var(--shadow-focus-primary);
}

.drawer-trigger z-icon {
  --z-icon-width: calc(var(--space-unit) * 4);
  --z-icon-height: calc(var(--space-unit) * 4);

  fill: var(--color-default-icon);
}

.drawer-content {
  display: none;
}

z-offcanvas {
  --z-offcanvas--top-space: var(--app-header-top-offset);
}

z-offcanvas[open] .drawer-content {
  display: flex;
  width: 100%;
  flex: 1 auto;
  flex-direction: column;
}

z-offcanvas[open] .drawer-content ::slotted(z-menu) {
  width: 100%;
}

.drawer-close {
  --z-icon-width: calc(var(--space-unit) * 4);
  --z-icon-height: calc(var(--space-unit) * 4);

  padding: 0;
  border: 0;
  margin: var(--space-unit) 0 calc(var(--space-unit) * 2.5);
  appearance: none;
  background: transparent;
  border-radius: 0;
  cursor: pointer;
  outline: none;
}

.drawer-close z-icon {
  fill: var(--color-default-icon);
}

.drawer-close:focus:focus-visible {
  box-shadow: var(--shadow-focus-primary);
}

@media (max-width: 767px) {
  :host([enable-search]) .heading-panel .heading-container {
    row-gap: calc(var(--space-unit) * 1.5);
  }
}

/* Tablet breakpoint */
@media (min-width: 768px) {
  .heading-panel {
    --title-font-size: var(--font-size-9);

    padding: calc(var(--space-unit) * 1.5) var(--grid-margin) calc(var(--space-unit) * 1.25);
  }

  :host([enable-search][search-page-url]) .heading-panel .heading-container {
    flex-direction: column;
  }

  .heading-panel .heading-container {
    flex-direction: column;
    margin-right: auto;
  }

  .z-logo img {
    height: 32px;
  }

  .product-logo {
    display: flex;
    height: calc(var(--title-font-size) * var(--title-line-height));
    align-items: center;
  }

  z-searchbar {
    width: 30%;
    height: calc(var(--title-font-size) * var(--title-line-height));
    margin-left: auto;
  }

  .menu-container {
    flex: initial;
  }

  .menu-container > [role="menubar"] {
    display: contents;
  }

  :host(:not([enable-offcanvas])) .menu-container {
    margin-top: calc((var(--space-unit) * 1.75));
  }

  :host(:not([enable-offcanvas])) .heading-container .drawer-trigger {
    display: none;
  }

  .heading-stuck .heading-title {
    --title-font-size: var(--font-size-8);
    --title-line-height: 1.5;
  }

  .heading-stuck-content {
    padding: 6px var(--grid-margin);
  }

  :host(:not([enable-offcanvas], [menu-length="0"])) {
    padding-left: 0;
  }
}

/* Desktop breakpoint */
@media (min-width: 1152px) {
  z-searchbar {
    min-width: calc(var(--space-unit) * 45);
  }
}

@keyframes slide-stuck-heading-in {
  0% {
    transform: translate3d(0, -100%, 0);
  }

  100% {
    transform: none;
  }
}
